import { render, staticRenderFns } from "./jy-receiptGoodsDetail.vue?vue&type=template&id=ce160cca&scoped=true&"
import script from "./jy-receiptGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./jy-receiptGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./jy-receiptGoodsDetail.vue?vue&type=style&index=0&id=ce160cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce160cca",
  null
  
)

export default component.exports